var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "	<div class=\"form-item mobile-code\" style=\"position: relative;\">\n    <button id=\"getActiveCode\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.getMobileCode : stack1), depth0))
    + "</button>\n    <input id=\"mobile-code\" class=\"enhancer-input\"  type=\"text\"  name=\"mobileCode\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.mobileCode : stack1), depth0))
    + "\">\n    <label for=\"mobile-code\"></label>\n    <div class=\"mobile-code-tip\">\n      <a href=\"#1\" tabindex=\"-1\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.notMobileCode : stack1), depth0))
    + "</a>\n    </div>\n  </div>\n  <input type=\"hidden\" name=\"account\" />\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<h1 class=\"resetpwd-title\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.resetPassword : stack1), depth0))
    + "</h1>\n<form action=\""
    + alias2(alias1((depth0 != null ? depth0.actionUrl : depth0), depth0))
    + "\" method=\"post\" role=\"form\" class=\"resetpwd-form\">\n\n  <div class=\"form-item\">\n    <input id=\"password\" class=\"enhancer-input\" type=\"password\" name=\"password\" placeholder=\"New Password\">\n    <label for=\"password\"></label>\n    <input type=\"hidden\" name=\"token\">\n  </div>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showCode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  <div class=\"form-item\">\n    <button class=\"enhancer-btn submit\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.submit : stack1), depth0))
    + "</button>\n  </div>\n</form>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/resetPassword/resetPassword.html
// module id = 45
// module chunks = 5